<ng-container *transloco="let t;">
    <div class="form-group mb-0 w-100">
        <ng-select [multiple]="false"
                   [closeOnSelect]="true"
                   [items]="items"
                   [ngModel]="value"
                   [disabled]="isDisabled"
                   (ngModelChange)="onModelChange($event)"
                   (touchend)="onControlTouched($event)"
                   [placeholder]="t('Advanced filter operators select placeholder (Advanced filters) - Select')">
            <ng-template ng-option-tmp ng-label-tmp let-item="item">
                {{ t(AdvancedFiltersOperatorTranslations[item]) }}
            </ng-template>

        </ng-select>
    </div>
</ng-container>